import { chargeMethodList } from 'constants/lists';
import { deepCloneObject, isNotNullUndefined } from 'functions';
import { recursiveBillingSetupConstants } from '../constants';

export function recursiveBillingSetupReducers(state = {}, action) {
    switch (action.type) {
            
        // Set Master

        case recursiveBillingSetupConstants.setMaster_request:
            return {
                ...state,
                setMaster_requesting: true, setMaster_status: false, 
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true
            }
        case recursiveBillingSetupConstants.setMaster_success:
            return {
                ...state,
                setMaster_requesting: false, setMaster_status: true, 
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.setMaster_failure:
            return {
                ...state,
                setMaster_requesting: false, setMaster_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false
            }

        // Add Account

        case recursiveBillingSetupConstants.addAccount_request:
            return {
                ...state,
                addAccount_requesting: true, addAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                addAccount_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.addAccount_success:
            return {
                ...state,
                addAccount_requesting: false, addAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.addAccount_failure:
            return {
                ...state,
                addAccount_requesting: false, addAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                addAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Add Multi Account

        case recursiveBillingSetupConstants.addMultiAccount_request:
            return {
                ...state,
                addMultiAccount_requesting: true, addMultiAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                addMultiAccount_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.addMultiAccount_success:
            return {
                ...state,
                addMultiAccount_requesting: false, addMultiAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.addMultiAccount_failure:
            return {
                ...state,
                addMultiAccount_requesting: false, addMultiAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                addMultiAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Delete Account

        case recursiveBillingSetupConstants.deleteAccount_request:
            return {
                ...state,
                deleteAccount_requesting: true, deleteAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                deleteAccount_errorMsg: undefined
            }
        case recursiveBillingSetupConstants.deleteAccount_success:
            return {
                ...state,
                deleteAccount_requesting: false, deleteAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.deleteAccount_failure:
            return {
                ...state,
                deleteAccount_requesting: false, deleteAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                deleteAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Deactivate Account

        case recursiveBillingSetupConstants.deactivateAccount_request:
            return {
                ...state,
                deactivateAccount_requesting: true, deactivateAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                deactivateAccount_errorMsg: undefined
            }
        case recursiveBillingSetupConstants.deactivateAccount_success:
            return {
                ...state,
                deactivateAccount_requesting: false, deactivateAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.deactivateAccount_failure:
            return {
                ...state,
                deactivateAccount_requesting: false, deactivateAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                deactivateAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Update Account

        case recursiveBillingSetupConstants.updateAccount_request:
            return {
                ...state,
                updateAccount_requesting: true, updateAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                updateAccount_errorMsg: undefined
            }
        case recursiveBillingSetupConstants.updateAccount_success:
            return {
                ...state,
                updateAccount_requesting: false, updateAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.updateAccount_failure:
            return {
                ...state,
                updateAccount_requesting: false, updateAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                updateAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Get Dealer Code List

        case recursiveBillingSetupConstants.getExistingDealerCodeList_request:
            return {
                ...state,
                getExistingDealerCodeList_requesting: true, getExistingDealerCodeList_status: false,
            }
        case recursiveBillingSetupConstants.getExistingDealerCodeList_success:
            return {
                ...state,
                getExistingDealerCodeList_requesting: false, getExistingDealerCodeList_status: true,
                existingDealerCodeList: action.details.data,
            }
        case recursiveBillingSetupConstants.getExistingDealerCodeList_failure:
            return {
                ...state,
                getExistingDealerCodeList_requesting: false, getExistingDealerCodeList_status: false, 
            }

            
        // Get Sales Person Code List

        case recursiveBillingSetupConstants.getExistingSalesPersonCodeList_request:
            return {
                ...state,
                getExistingSalesPersonCodeList_requesting: true, getExistingSalesPersonCodeList_status: false,
            }
        case recursiveBillingSetupConstants.getExistingSalesPersonCodeList_success:
            return {
                ...state,
                getExistingSalesPersonCodeList_requesting: false, getExistingSalesPersonCodeList_status: true,
                existingSalesPersonCodeList: action.details.data,
            }
        case recursiveBillingSetupConstants.getExistingSalesPersonCodeList_failure:
            return {
                ...state,
                getExistingSalesPersonCodeList_requesting: false, getExistingSalesPersonCodeList_status: false, 
            }


        // Update Dealer Code

        case recursiveBillingSetupConstants.updateDealerCode_request:
            return {
                ...state,
                updateDealerCode_requesting: true, updateDealerCode_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                updateDealerCode_errorMsg: undefined
            }
        case recursiveBillingSetupConstants.updateDealerCode_success:
            return {
                ...state,
                updateDealerCode_requesting: false, updateDealerCode_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.updateDealerCode_failure:
            return {
                ...state,
                updateDealerCode_requesting: false, updateDealerCode_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                updateDealerCode_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Update Sales Person Code

        case recursiveBillingSetupConstants.updateSalesPersonCode_request:
            return {
                ...state,
                updateSalesPersonCode_requesting: true, updateSalesPersonCode_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                updateSalesPersonCode_errorMsg: undefined
            }
        case recursiveBillingSetupConstants.updateSalesPersonCode_success:
            return {
                ...state,
                updateSalesPersonCode_requesting: false, updateSalesPersonCode_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case recursiveBillingSetupConstants.updateSalesPersonCode_failure:
            return {
                ...state,
                updateSalesPersonCode_requesting: false, updateSalesPersonCode_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                updateSalesPersonCode_errorMsg: action?.error?.response?.data?.exceptionMessage
            }


        // Get All Billing Setup

        case recursiveBillingSetupConstants.getAllBillingSetup_request:
            return {
                ...state,
                getAllBillingSetup_requesting: true, getAllBillingSetup_status: false,
            }
        case recursiveBillingSetupConstants.getAllBillingSetup_success:
            return {
                ...state,
                getAllBillingSetup_requesting: false, getAllBillingSetup_status: true,
                allBillingSetup: action.details.data,
            }
        case recursiveBillingSetupConstants.getAllBillingSetup_failure:
            return {
                ...state,
                getAllBillingSetup_requesting: false, getAllBillingSetup_status: false, 
            }


        // Get Billing Setup

        case recursiveBillingSetupConstants.getBillingSetup_request:
            return {
                ...state,
                getBillingSetup_requesting: true, getBillingSetup_status: false,
            }
        case recursiveBillingSetupConstants.getBillingSetup_success:
            return {
                ...state,
                getBillingSetup_requesting: false, getBillingSetup_status: true,
                billingSetup: action?.details?.data.map((obj) => {
                    let newObj = deepCloneObject(obj);
                    newObj.ChargeMethod = isNotNullUndefined(obj?.ChargeMethod) && obj?.ChargeMethod >= 0? chargeMethodList[obj?.ChargeMethod]?.label:"";
                    return newObj;
                }),
                billingSetupHeaders: action.details.headers,
            }
        case recursiveBillingSetupConstants.getBillingSetup_failure:
            return {
                ...state,
                getBillingSetup_requesting: false, getBillingSetup_status: false, 
            }
            
        // Get Unbill Billing Setup

        case recursiveBillingSetupConstants.getUnbillBillingSetup_request:
            return {
                ...state,
                getUnbillBillingSetup_requesting: true, getUnbillBillingSetup_status: false,
            }
        case recursiveBillingSetupConstants.getUnbillBillingSetup_success:
            return {
                ...state,
                getUnbillBillingSetup_requesting: false, getUnbillBillingSetup_status: true,
                billingSetup: action.details.data,
                billingSetupHeaders: action.details.headers,
            }
        case recursiveBillingSetupConstants.getUnbillBillingSetup_failure:
            return {
                ...state,
                getUnbillBillingSetup_requesting: false, getUnbillBillingSetup_status: false, 
            }

        // Get Nonautomated Account List

        case recursiveBillingSetupConstants.getNonautomatedAccountList_request:
            return {
                ...state,
                getNonautomatedAccountList_requesting: true, getNonautomatedAccountList_status: false,
            }
        case recursiveBillingSetupConstants.getNonautomatedAccountList_success:
            return {
                ...state,
                getNonautomatedAccountList_requesting: false, getNonautomatedAccountList_status: true,
                nonautomatedAccountList: action.details.data,
            }
        case recursiveBillingSetupConstants.getNonautomatedAccountList_failure:
            return {
                ...state,
                getNonautomatedAccountList_requesting: false, getNonautomatedAccountList_status: false, 
            }

        // Get Automated Account List

        case recursiveBillingSetupConstants.getAutomatedAccountList_request:
            return {
                ...state,
                getAutomatedAccountList_requesting: true, getAutomatedAccountList_status: false,
            }
        case recursiveBillingSetupConstants.getAutomatedAccountList_success:
            return {
                ...state,
                getAutomatedAccountList_requesting: false, getAutomatedAccountList_status: true,
                automatedAccountList: action.details.data,
            }
        case recursiveBillingSetupConstants.getAutomatedAccountList_failure:
            return {
                ...state,
                getAutomatedAccountList_requesting: false, getAutomatedAccountList_status: false, 
            }

        // Remove Automated Accounts

        case recursiveBillingSetupConstants.removeAutomatedAccounts_request:
            return {
                ...state,
                removeAutomatedAccounts_requesting: true, removeAutomatedAccounts_status: false,
            }
        case recursiveBillingSetupConstants.removeAutomatedAccounts_success:
            return {
                ...state,
                removeAutomatedAccounts_requesting: false, removeAutomatedAccounts_status: true,
            }
        case recursiveBillingSetupConstants.removeAutomatedAccounts_failure:
            return {
                ...state,
                removeAutomatedAccounts_requesting: false, removeAutomatedAccounts_status: false, 
            }

        // Add Automated Accounts

        case recursiveBillingSetupConstants.addAutomatedAccounts_request:
            return {
                ...state,
                addAutomatedAccounts_requesting: true, addAutomatedAccounts_status: false,
            }
        case recursiveBillingSetupConstants.addAutomatedAccounts_success:
            return {
                ...state,
                addAutomatedAccounts_requesting: false, addAutomatedAccounts_status: true,
            }
        case recursiveBillingSetupConstants.addAutomatedAccounts_failure:
            return {
                ...state,
                addAutomatedAccounts_requesting: false, addAutomatedAccounts_status: false, 
            }

        // Delete All Billing Setup

        case recursiveBillingSetupConstants.deleteAllBillingSetup_request:
            return {
                ...state,
                deleteAllBillingSetup_requesting: true, deleteAllBillingSetup_status: false,
            }
        case recursiveBillingSetupConstants.deleteAllBillingSetup_success:
            return {
                ...state,
                deleteAllBillingSetup_requesting: false, deleteAllBillingSetup_status: true,
            }
        case recursiveBillingSetupConstants.deleteAllBillingSetup_failure:
            return {
                ...state,
                deleteAllBillingSetup_requesting: false, deleteAllBillingSetup_status: false, 
            }
            
        // Import Mass Billing Setup
        
        case recursiveBillingSetupConstants.importMassBillingSetup_request:
            return {
                ...state,
                importMassBillingSetup_requesting: true, importMassBillingSetup_status: false,
                importMassBillingSetup_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.importMassBillingSetup_success:
            return {
                ...state,
                importMassBillingSetup_requesting: false, importMassBillingSetup_status: true,
            }
        case recursiveBillingSetupConstants.importMassBillingSetup_failure:
            return {
                ...state,
                importMassBillingSetup_requesting: false, importMassBillingSetup_status: false, 
                importMassBillingSetup_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Get Remarks

        case recursiveBillingSetupConstants.getRemarks_request:
            return {
                ...state,
                getRemarks_requesting: true, getRemarks_status: false,
                getRemarks_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.getRemarks_success:
            return {
                ...state,
                getRemarks_requesting: false, getRemarks_status: true,
                billingSetupRemarks: action.details.data
            }
        case recursiveBillingSetupConstants.getRemarks_failure:
            return {
                ...state,
                getRemarks_requesting: false, getRemarks_status: false, 
                getRemarks_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

            
        // Update Remarks

        case recursiveBillingSetupConstants.updateRemarks_request:
            return {
                ...state,
                updateRemarks_requesting: true, updateRemarks_status: false,
                updateRemarks_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.updateRemarks_success:
            return {
                ...state,
                updateRemarks_requesting: false, updateRemarks_status: true,
            }
        case recursiveBillingSetupConstants.updateRemarks_failure:
            return {
                ...state,
                updateRemarks_requesting: false, updateRemarks_status: false, 
                updateRemarks_errorMsg: action?.error?.response?.data?.exceptionMessage
            }


        // Get Full Agent Code List

        case recursiveBillingSetupConstants.getFullAgentCodeList_request:
            return {
                ...state,
                getFullAgentCodeList_requesting: true, getFullAgentCodeList_status: false,
                getFullAgentCodeList_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.getFullAgentCodeList_success:
            return {
                ...state,
                getFullAgentCodeList_requesting: false, getFullAgentCodeList_status: true,
                fullAgentCodeList: action.details.data
            }
        case recursiveBillingSetupConstants.getFullAgentCodeList_failure:
            return {
                ...state,
                getFullAgentCodeList_requesting: false, getFullAgentCodeList_status: false, 
                getFullAgentCodeList_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Get Full Product Code List

        case recursiveBillingSetupConstants.getFullProductDetailList_request:
            return {
                ...state,
                getFullProductDetailList_requesting: true, getFullProductDetailList_status: false,
                getFullProductDetailList_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.getFullProductDetailList_success:
            return {
                ...state,
                getFullProductDetailList_requesting: false, getFullProductDetailList_status: true,
                fullProductCodeList: action.details.data
            }
        case recursiveBillingSetupConstants.getFullProductDetailList_failure:
            return {
                ...state,
                getFullProductDetailList_requesting: false, getFullProductDetailList_status: false, 
                getFullProductDetailList_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Get Full Product Code 

        case recursiveBillingSetupConstants.getFullProductDetail_request:
            return {
                ...state,
                getFullProductDetail_requesting: true, getFullProductDetail_isSuccessful: false,
                getFullProductDetail_errorMsg: undefined,
            }
        case recursiveBillingSetupConstants.getFullProductDetail_success:
            return {
                ...state,
                getFullProductDetail_requesting: false, getFullProductDetail_isSuccessful: true,
                fullProductDetail: action.details.data
            }
        case recursiveBillingSetupConstants.getFullProductDetail_failure:
            return {
                ...state,
                getFullProductDetail_requesting: false, getFullProductDetail_isSuccessful: false, 
                getFullProductDetail_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        default:
            return state;
    }
}